<template>
  <transition name="modal-fade">
    <div class="modal-backdrop">
      <div class="modal"
        role="dialog"
        aria-labelledby="modalTitle"
        aria-describedby="modalDescription"
      >
        <div class="btn-close-container">
          <button
            type="button"
            class="btn-close"
            @click="close"
            aria-label="Close modal"
          >
            <span>close</span><div class="close-icon"><v-icon path="icons/close.svg" /></div>
          </button>
        </div>

        <header
          class="modal-header"
          id="modalTitle"
        >
          <div class="modal-header-row"><img v-bind:src="require('../assets/' + headerImageName)" /></div>
          <slot name="header">
            <div>
              <div class="modal-header-row"><h3>This is the default tile!</h3></div>
            </div>
          </slot>
        </header>
        <section
          class="modal-body"
          id="modalDescription"
        >
          <slot name="body">
            <div>
              <p>I'm the default body! This will be the modal text that will come from parent components.</p>
            </div>
          </slot>
        </section>
        <footer class="modal-footer">
          <slot name="footer">
            <div>
              <a href="./example1.php" class="btn btn-dark text-uppercase-spaced">Dark CTA Button</a>
              <a href="./example2.php" class="btn btn-outline-dark text-uppercase-spaced">Light CTA Button</a>
            </div>
          </slot>
        </footer>
      </div>
    </div>
  </transition>
</template>



<script>
  import VIcon from './VIcon';

  export default {
    name: 'modal',
    props: {
      headerImageName: String,
    },
    methods: {
      close() {
        this.$emit('close');
      },
    },
    components: {
      VIcon
    }
  };
</script>



<style>
  #app .modal-backdrop {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index:10000;
  }

  #app .modal {
    max-width:500px;
    min-width:90%;
    border-top:15px solid #000000;
    border-bottom:15px solid #ffffff;
    background: #FFFFFF;
    -webkit-box-shadow: 0px 5px 10px 0px rgba(0,0,0,0.2);
    -moz-box-shadow: 0px 5px 10px 0px rgba(0,0,0,0.2);
    box-shadow: 0px 5px 10px 0px rgba(0,0,0,0.2);;
    overflow-x: auto;
    display: flex;
    flex-direction: column;
  }

  /* Small devices (landscape phones, 576px and up) */
  @media (min-width: 576px) {
    #app .modal {
      min-width:360px;
    }
  }

  /* Medium devices (tablets, 768px and up) */
  @media (min-width: 768px) {
    #app .modal {

    }
  }

  #app .modal .btn-close-container {

  }

  #app .modal-header,
  #app .modal-footer {
    padding: 5px 15px;
  }

  #app .modal-header {
    color: #4AAE9B;
    justify-content: space-between;
  }

  #app .modal-header .modal-header-row {
    display:block;
    width:100%;
  }

  #app .modal-header img {
    display:block;
    margin:20px auto;
  }

  #app .modal-header h3 {
    display: block;
    margin: 0 auto;
    color: #000000;
    font-size: 18px;
    font-weight: 700;
    text-align:center;
    line-height:1.5;
  }

  #app .modal-footer {
    justify-content: flex-end;
  }

  #app .modal-body {
    padding: 20px 10px;
  }

  #app .modal-body p {
    font-size:12px;
    text-align:center;
    line-height:1.5;
  }

  #app .btn-close-container {
    position:relative;
    display: block;
    width: 100%;
  }

  #app .btn {
    display:block;
    text-align:center;
    padding:10px;
    font-weight:bold;
    margin-bottom:10px;
  }

  #app .text-uppercase-spaced {
    text-transform: uppercase;
    letter-spacing: 0.07rem;
  }


  #app .btn-dark {
    background:#000000;
    color:#ffffff;
  }

  #app .btn-outline-dark {
    background:#ffffff;
    color:#000000;
    border:1px solid #000000;

  }

  #app .btn-close {
    position: absolute;
    top: 0px;
    right: 0px;
    border: none;
    font-size: 12px;
    padding: 10px;
    cursor: pointer;
    font-weight: bold;
    color: black;
    background: transparent;
    text-transform: uppercase;
    z-index:10001;
  }

  #app .btn-close span {
    display: inline-block;
    vertical-align: middle;
    line-height: normal;
    margin-right:5px;
  }

  #app .btn-close .close-icon {
    display: inline-block;
    width: 12px;
    height: 1em;
    margin-right: 0;
    align-items: center;
    justify-content: center;
    vertical-align: middle;
    line-height: normal;
  }

  #app .btn-green {
    color: white;
    background: #4AAE9B;
    border: 1px solid #4AAE9B;
    border-radius: 2px;
  }


</style>
